import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-brightness-high",
  templateUrl: "./med-icon-brightness-high.component.html",
})
export class MedIconBrightnessHighComponent extends SvgMixinComponent {}
